// Code generated by Prismic. DO NOT EDIT.

import CallToAction from "./CallToAction";
import Divider from "./Divider";
import FileAttachment from "./FileAttachment";
import Heading from "./Heading";
import Image from "./Image";
import MythsVsFacts from "./MythsVsFacts";
import Notification from "./Notification";
import OrderedList from "./OrderedList";
import PageHeroHeadline from "./PageHeroHeadline";
import Products from "./Products";
import Region from "./Region";
import RegionComplex from "./RegionComplex";
import RichText from "./RichText";
import Table from "./Table";
import UnorderedList from "./UnorderedList";

export const components = {
	call_to_action: CallToAction,
	divider: Divider,
	file_attachment: FileAttachment,
	heading: Heading,
	image: Image,
	myths_vs_facts: MythsVsFacts,
	notification: Notification,
	ordered_list: OrderedList,
	page_hero_headline: PageHeroHeadline,
	products: Products,
	region: Region,
	region_complex: RegionComplex,
	rich_text: RichText,
	table: Table,
	unordered_list: UnorderedList
};